<template>
    <div class="content">
        <el-row class="top-box">
            <div class="nav-logo-box">
            </div>
            <!-- 用户信息 -->
            <div class="top-user-box">
                <el-row>
                    <el-col :span="24">
                        <el-dropdown trigger="click" @command="userinfoNavSelect">
                            <span class="el-dropdown-link">
                                    {{userInfo.userName}}<i class="el-icon-caret-bottom el-icon--right"></i>
                                    </span>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item :command="index.toString()" v-for="(userItem, index) in userNavData" :key="userItem.name">{{userItem.title}}</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </el-col>
                </el-row>
            </div>
            <!-- end -->
            <!-- 顶部导航 -->
            <div class="top-nav-box">
                <el-row>
                    <el-col :span="24">
                        <el-menu theme="dark" :default-active="navActive" class="el-menu-demo" @select="navSelectedHandle" mode="horizontal">
                            <el-submenu :index="moduleItem.name" v-for="moduleItem in topNavPerData" :key="moduleItem.route">
                              <template slot="title">{{moduleItem.title}}</template>
                              <el-menu-item :index="navItem.name" v-for="navItem in moduleItem.children" :key="navItem.name">{{navItem.title}}</el-menu-item>
                            </el-submenu>
                            <el-menu-item :index="navItem.name" v-for="navItem in topNavCommonData" :key="navItem.name">{{navItem.title}}</el-menu-item>
                        </el-menu>
                    </el-col>
                </el-row>
            </div>
            <!-- end -->
        </el-row>
        <el-row class="main-box">
            <el-col :span="3" class="left-nav-box">
                <el-menu theme="dark" :default-active="navActive" :unique-opened="true" @select="navSelectedHandle" class="left-nav-menu">
                    <el-submenu :index="moduleItem.name" v-for="moduleItem in leftNavData" :key="moduleItem.route">
                        <template slot="title">{{moduleItem.title}}</template>
                        <el-menu-item :index="navItem.name" v-for="navItem in moduleItem.children" :key="navItem.name">{{navItem.title}}</el-menu-item>
                    </el-submenu>
                </el-menu>
            </el-col>
            <div class="content-box">
                <router-view></router-view>
            </div>
        </el-row>
        <el-dialog title="修改密码" v-model="config.changePwdDialog.visible" :lock-scroll="true" @close="clearPwdFormData">
            <el-form :model="changePwdForm" :rules="validateRules" ref="changePwdForm">
                <el-form-item label="旧密码" :label-width="config.changePwdDialog.formLabelWidth" prop="oldPassword">
                    <el-input type="password" v-model="changePwdForm.oldPassword" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="新密码" :label-width="config.changePwdDialog.formLabelWidth" prop="newPassword">
                    <el-input type="password" v-model="changePwdForm.newPassword" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="确认密码" :label-width="config.changePwdDialog.formLabelWidth" prop="confirmPassword">
                    <el-input type="password" v-model="changePwdForm.confirmPassword" auto-complete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="config.changePwdDialog.visible = false">取 消</el-button>
                <el-button type="primary" @click="changePassword('changePwdForm')">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import CONFIG from "@/config/index.js";
import TOOL from '@/tool/index.js';
import router from "@/router/index.js";
import { mapGetters, mapActions } from 'vuex';
export default {
    name: "content",
    data() {
        return {
            navActive: null,
            leftNavData: [],
            topNavCommonData: CONFIG.TOP_COMMON_NAV,
            topNavPerData: [],
            userNavData: CONFIG.USER_NAV,
            _rootURL: null,
            changePwdForm: {
                oldPassword: null,
                newPassword: null,
                confirmPassword: null
            },
            config: {
                contentBoxWidth: 0,
                mainBoxHeight: 0,
                changePwdDialog: {
                    visible: false,
                    formLabelWidth: '120px'
                }
            },
            validateRules: {
                oldPassword: [
                    { required: true, message: '请填写现在密码', trigger: 'blur' },
                ],
                newPassword: [
                    { required: true, message: '请填写新密码', trigger: 'blur' },
                    { min: 6, message: '长度至少 6 个字符', trigger: 'blur' }
                ],
                confirmPassword: [
                    { required: true, message: '请再一次填写新密码', trigger: 'blur' },
                    { min: 6, message: '长度至少 6 个字符', trigger: 'blur' }
                ]
            }
        };
    },
    computed: {
        ...mapGetters({
            userInfo: 'getUserInfo'
        })
    },
    mounted() {

    },
    created(){
        this._init();
    },
    methods: {
        ...mapActions([
            'init'
        ]),
        navSelectedHandle(key, keyPath, e) {
            this.navActive = key;
            router.push({ name: key});
        },
        userinfoNavSelect(arrIndex){
            CONFIG.USER_NAV[arrIndex].action(this, router);
        },
        validate() {
            let $route = this.$route;
            if(!$route.params || !$route.params.userId || !$route.params.accountEmail || !$route.params.version) {
                router.push({
                    name: 'Login'
                });
            }
            return;
        },
        clearPwdFormData() {
            this.changePwdForm.oldPassword = null;
            this.changePwdForm.newPassword = null;
            this.changePwdForm.confirmPassword = null;
        },
        changePassword(formName) {
            let flag = true;
            this.$refs[formName].validate((valid) => {
                if (!valid) {
                    flag = false;
                    return false;
                }
            });
            if (!flag) {
                return;
            }
            if (this.changePwdForm.newPassword !== this.changePwdForm.confirmPassword) {
                this.$notify.error({
                    message: '两次输入密码不一致'
                });
                return;
            }
            let pwdData = {
                password: md5(this.changePwdForm.oldPassword),
                newPassword: md5(this.changePwdForm.newPassword)
            };
            this.$http.put(CONFIG.HOST + "/users/updataPasswordBySelf/" + this.userInfo.userId, pwdData).then((response)=> {
                let result = response.body;
                if (result && result.status === 1) {
                    this.$notify.success({
                        message: '密码修改成功'
                    });
                    this.config.changePwdDialog.visible = false;
                } else {
                    this.$notify.error({
                        message: result.message
                    });
                }
            },(response)=> {
                console.log(response);
            });
        },
        _getPermission(userId, accountEmail, callback) {
            this.$http.get(CONFIG.HOST + '/users/getUserById?userId=' + userId + '&accountEmail=' + accountEmail + '&t=' + TOOL.getCurrentTime()).then((response) => {
                let result = response.body;
                if (result && result.status === 1 && result.data.length > 0) {
                    if (callback) {
                        callback(result.data[0]);
                    } else {
                        console.error("【营销平台】获取用户权限callback为空");
                    }
                } else {
                    this.$notify.error({
                        message: result.message
                    });
                }
            }, (response) => {
                console.log(response);
            });
        },
        _setPermission(roleName) {
            if(!roleName){
                router.push({
                    name: 'Login'
                });
                return;
            }
            for (var arrItem of CONFIG.LEFT_NAV_PERMISSION) {
                if (arrItem.name === roleName) {
                    if(arrItem.permission && Array.isArray(arrItem.permission)){
                        for(var permissionItem of arrItem.permission) {
                            let tmpItem = {
                                title: CONFIG.NAV_DATA[permissionItem.arrIndex].title,
                                route: CONFIG.NAV_DATA[permissionItem.arrIndex].route,
                                name: CONFIG.NAV_DATA[permissionItem.arrIndex].name,
                                children: []
                            };
                            for(var permissionIndex of permissionItem.children) {
                                tmpItem.children.push(CONFIG.NAV_DATA[permissionItem.arrIndex].children[permissionIndex]);
                            }
                            this.leftNavData.push(tmpItem);
                        }
                    }
                    break;
                }
            }
            for (var arrItem of CONFIG.TOP_NAV_PERMISSION) {
                if (arrItem.name === roleName) {
                    if(arrItem.permission && Array.isArray(arrItem.permission)){
                        for(var permissionItem of arrItem.permission) {
                            let tmpItem = {
                                title: CONFIG.NAV_DATA[permissionItem.arrIndex].title,
                                route: CONFIG.NAV_DATA[permissionItem.arrIndex].route,
                                name: CONFIG.NAV_DATA[permissionItem.arrIndex].name,
                                children: []
                            };
                            for(var permissionIndex of permissionItem.children) {
                                tmpItem.children.push(CONFIG.NAV_DATA[permissionItem.arrIndex].children[permissionIndex]);
                            }
                            this.topNavPerData.push(tmpItem);
                        }
                    }
                    return;
                }
            }
        },
        _init() {
            this.validate();
            let $route = this.$route;
            this._rootURL = $route.path;
            let that = this;
            if ($route.name !== "Content") {
                this.navActive = $route.name;
            }
            router.beforeEach((to, from, next)=>{
                that.navActive = to.name;
                next();
            });
            let _users = {
                userId: Base64.decode($route.params.userId),
                accountEmail: Base64.decode($route.params.accountEmail)
            };
            this._getPermission(_users.userId, _users.accountEmail, (permissionInfo) => {
                this.init({
                    userId: permissionInfo.userId,
                    accountEmail: permissionInfo.accountEmail,
                    userName: permissionInfo.userName,
                    permissionsId: permissionInfo.permissionsId,
                    permissionsName: permissionInfo.permissionsName
                });
                this._setPermission(permissionInfo.permissionsName);
            });
        }
    }
};
</script>
<style lang="less">
.top-box {
    width: 100%;
    height: 60px;

    position: absolute;
    top: 0;
    z-index: 1;
    background-color: #324157;

    margin-bottom: 0;

    .el-col {
        border-radius: 0;
    }
    .nav-logo-box {
        width: 200px;
        height: 100%;

        position: absolute;
        left: 0;
        top: 0;

        background-image: url(http://tstatic.toptest.yidianzixun.com.ks3-cn-beijing.ksyun.com/public/files/logo1491900175336.png);
        background-repeat: no-repeat;
        background-size: 60%;
        background-position: center;

        text-align: center;
    }
    .top-user-box {
        height: 100%;

        position: absolute;
        right: 20px;
        top: 0;

        line-height: 60px;

        cursor: pointer;

        .el-dropdown {
            color: #F9FAFC;
        }
    }
    .top-nav-box {
        height: 100%;

        position: absolute;
        left: 240px;
        top: 0;
        line-height: 60px;
    }
}

.main-box {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0px;
    left: 0;
    overflow: hidden;

    margin: 0;
    padding-top: 60px;

    .left-nav-box {
        width: 220px;
        height: 100%;
        border-radius: 0;
        background-color: #324157;

        overflow: auto;

        position: absolute;
        left: 0;
        top: 0;

        padding-top: 60px;
    }
    .content-box {
        display: block;
        height: 100%;
        overflow-x: hidden;
        overflow-y: auto;
    }
}
</style>



// WEBPACK FOOTER //
// Index.vue?08d1001a